// <brook-page-hero data-parallax>: moves the hero photo down slowly while the page scrolls, so
// it drifts behind the text like the GemPages parallax heroes did. Same rate as theirs: 1 px
// per 12 px scrolled since the hero came into view, capped at the 45 px of photo kept above
// the hero (brook-page-hero.css), so its top edge never shows. The shift goes into
// --brook-parallax-shift. Still for people who prefer reduced motion, including when they
// switch it on while the page is open. A custom element so it also works after Customize
// re-renders the section. Used by sections/brook-page-hero.liquid.
if (!customElements.get('brook-page-hero')) {
  const RATE = 1 / 12;
  const MAX_SHIFT = 45;

  customElements.define(
    'brook-page-hero',
    class extends HTMLElement {
      reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      frame = null;

      connectedCallback() {
        if (!this.hasAttribute('data-parallax')) return;
        this.reducedMotion.addEventListener('change', this.onMotionChange);
        this.onMotionChange();
      }

      disconnectedCallback() {
        this.reducedMotion.removeEventListener('change', this.onMotionChange);
        this.stop();
      }

      onMotionChange = () => {
        if (this.reducedMotion.matches) {
          this.stop();
          this.style.removeProperty('--brook-parallax-shift');
        } else {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }
      };

      stop() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };

      update = () => {
        this.frame = null;
        const rect = this.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        // How far the page has scrolled since the hero's top entered the viewport; 0 for a
        // hero that's on screen when the page opens.
        const top = rect.top + window.scrollY;
        const scrolled = Math.max(0, window.scrollY - Math.max(0, top - window.innerHeight));
        const shift = Math.min(MAX_SHIFT, scrolled * RATE);
        this.style.setProperty('--brook-parallax-shift', `${shift}px`);
      };
    }
  );
}
